/* JoDi Shop — Reiter unter dem Produkt als Tab-Leiste
   Sucht alle Accordion-Trigger auf der Produktseite, egal wie sie
   verschachtelt sind, und baut daraus eine horizontale Tab-Leiste.

   NEUEN REITER ANLEGEN
   Theme-Editor → Produktseite → Produktinformationen → Block hinzufügen →
   „Aufklappbarer Abschnitt" (Collapsible tab). Überschrift = Reiterbeschriftung,
   Inhalt = Text des Reiters. Dieses Skript wandelt ihn automatisch in einen
   Reiter um; die Reihenfolge der Blöcke ist die Reihenfolge der Reiter.
   Leere Blöcke werden übersprungen.

   STARTREITER FESTLEGEN
   Unten die Beschriftung des Reiters eintragen, der beim Aufrufen der Seite
   offen sein soll — genau so geschrieben wie im Theme-Editor, Groß- und
   Kleinschreibung ist dabei egal. Leer lassen heißt: der erste Reiter ist offen. */
var JODI_START_REITER = '';

/* MERKBLATT „GESETZLICHE GEWÄHRLEISTUNG"
   Rechtlich vorgegeben: das Merkblatt muss ohne Klick sichtbar sein.
   Es steht deshalb NICHT in einem Reiter, sondern als feste Spalte rechts
   neben Beschreibung und Reitern, auf jeder Produktseite.
   Am Handy steht es unter den Reitern. Im Theme-Editor ist nichts anzulegen.

   Gesetzliche_Gewaehrleistung.jpg hochladen unter Shopify Admin → Inhalte →
   Dateien, dann die Adresse der Datei kopieren und unten bei bild eintragen.
   Bleibt bild leer, erscheint die Spalte nicht.
   aktiv auf false blendet sie ebenfalls aus. */
var JODI_GEWAEHR = {
  aktiv: true,
  titel: 'Gesetzliche Gewährleistung',
  bild: '',
  bildAlt: 'Merkblatt der Europäischen Kommission zur gesetzlichen Gewährleistung',
  hinweis: 'Merkblatt der Europäischen Kommission. Zum Vergrößern anklicken.',
  quelle: 'https://europa.eu/youreurope/garantien',
  quelleText: 'Mehr zu Ihren Rechten'
};

(function () {
  function normLabel(s) {
    return (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function panelFor(btn) {
    var id = (btn.getAttribute('aria-controls') || '').replace('#', '');
    var p = id ? document.getElementById(id) : null;
    if (p) return p;
    var sib = btn.nextElementSibling;
    while (sib) {
      if (sib.classList && sib.classList.contains('collapsible-content')) return sib;
      sib = sib.nextElementSibling;
    }
    return btn.parentElement
      ? btn.parentElement.querySelector('.collapsible-content')
      : null;
  }

  /* gemeinsamer Elternknoten aller Trigger */
  function commonParent(nodes) {
    var chain = [];
    for (var n = nodes[0]; n; n = n.parentElement) chain.push(n);
    for (var i = 0; i < chain.length; i++) {
      var ok = true;
      for (var j = 1; j < nodes.length; j++) {
        if (!chain[i].contains(nodes[j])) { ok = false; break; }
      }
      if (ok) return chain[i];
    }
    return document.body;
  }

  /* feste Spalte rechts mit dem Merkblatt */
  function gewaehrSpalte() {
    if (!JODI_GEWAEHR || !JODI_GEWAEHR.aktiv || !JODI_GEWAEHR.bild) return null;
    var aside = document.createElement('aside');
    aside.className = 'jodi-gw';
    aside.setAttribute('aria-label', JODI_GEWAEHR.titel);
    aside.innerHTML =
      '<div class="jodi-gw__titel">' + JODI_GEWAEHR.titel + '</div>' +
      '<a class="jodi-gw__bild" href="' + JODI_GEWAEHR.bild + '" target="_blank" rel="noopener">' +
        '<img src="' + JODI_GEWAEHR.bild + '" alt="' + JODI_GEWAEHR.bildAlt + '" loading="lazy">' +
      '</a>' +
      '<p class="jodi-gw__hinweis">' + JODI_GEWAEHR.hinweis + '</p>' +
      '<a class="jodi-gw__link" href="' + JODI_GEWAEHR.quelle + '" target="_blank" rel="noopener">' +
        JODI_GEWAEHR.quelleText + '</a>';
    return aside;
  }

  function init() {
    /* Nur auf Produktseiten. Ohne diese Prüfung griff das Skript auch in
       Kollektionen und baute die Filter (Verfügbarkeit, Preis …) zu
       Reitern um — samt Merkblatt im Filterfenster. */
    var istProdukt =
      document.body.classList.contains('template-product') ||
      /\/products\//.test(window.location.pathname);
    if (!istProdukt) return;

    var scope =
      document.querySelector('.product-full-width') ||
      document.querySelector('[data-section-type="product"]');
    if (!scope || scope.dataset.jodiTabs) return;

    var triggers = [].slice.call(scope.querySelectorAll('.collapsible-trigger-btn'))
      .filter(function (btn) {
        return !btn.closest('.drawer, [class*="filter"], [id*="Filter"], form[action*="/collections"]');
      });
    if (triggers.length < 2) return;

    var items = [];
    triggers.forEach(function (btn) {
      var panel = panelFor(btn);
      if (!panel) return;
      var label = (btn.textContent || '').replace(/\s+/g, ' ').trim();
      var inner = panel.querySelector('.collapsible-content__inner') || panel;
      var hasText = (inner.textContent || '').replace(/\s|\u00a0/g, '') !== '';
      var hasMedia = !!inner.querySelector('img, table, iframe, video, ul, ol');
      if (!hasText && !hasMedia) {           /* leerer Reiter -> weg */
        var empty = btn.closest('.grid__item, .product-block, .collapsible-trigger') || btn.parentElement;
        if (empty) empty.style.display = 'none';
        panel.style.display = 'none';
        return;
      }
      if (label) items.push({ label: label, panel: panel, btn: btn });
    });
    if (items.length < 2) return;

    /* Produktbeschreibung als erster Tab */
    var descEl = null;
    var cands = scope.querySelectorAll('.rte, .product-single__description');
    for (var d = 0; d < cands.length; d++) {
      if (cands[d].closest('.collapsible-content')) continue;
      if (!(cands[d].textContent || '').trim()) continue;
      descEl = cands[d];
      break;
    }
    if (descEl) {
      items.unshift({ label: 'Beschreibung', panel: descEl, btn: null, isDesc: true });
    }

    var host = commonParent(items.filter(function (it) { return it.btn; }).map(function (it) { return it.btn; }));
    host.dataset.jodiTabs = '1';
    scope.dataset.jodiTabs = '1';

    var bar = document.createElement('div');
    bar.className = 'jodi-tabbar';
    var body = document.createElement('div');
    body.className = 'jodi-tabbody';

    /* gewünschter Startreiter, sonst der erste */
    var startIndex = 0;
    var gesucht = normLabel(JODI_START_REITER);
    if (gesucht) {
      for (var s = 0; s < items.length; s++) {
        if (normLabel(items[s].label) === gesucht) { startIndex = s; break; }
      }
    }

    items.forEach(function (item, i) {
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'jodi-tab' + (i === startIndex ? ' is-active' : '');
      tab.textContent = item.label;
      bar.appendChild(tab);

      var pane = document.createElement('div');
      pane.className = 'jodi-pane' + (i === startIndex ? ' is-active' : '');
      var inner = item.panel.querySelector('.collapsible-content__inner') || item.panel;
      pane.innerHTML = inner.innerHTML;
      body.appendChild(pane);

      tab.addEventListener('click', function () {
        bar.querySelectorAll('.jodi-tab').forEach(function (t) { t.classList.remove('is-active'); });
        body.querySelectorAll('.jodi-pane').forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        pane.classList.add('is-active');
      });
    });

    var shell = document.createElement('div');
    shell.className = 'jodi-tabs';
    shell.appendChild(bar);
    shell.appendChild(body);
    var anchor = (items[0] && items[0].isDesc && items[0].panel.parentNode === host.parentNode)
      ? items[0].panel : host;

    var spalte = gewaehrSpalte();
    if (spalte) {
      var layout = document.createElement('div');
      layout.className = 'jodi-underprod';
      layout.appendChild(shell);
      layout.appendChild(spalte);
      anchor.parentNode.insertBefore(layout, anchor);
    } else {
      anchor.parentNode.insertBefore(shell, anchor);
    }

    /* Original-Accordions ausblenden */
    items.forEach(function (item) {
      if (item.isDesc) { item.panel.style.display = 'none'; return; }
      var block =
        item.btn.closest('.grid__item, .product-block, .collapsible-trigger') ||
        item.btn.parentElement;
      if (block) block.style.display = 'none';
      item.panel.style.display = 'none';
    });
    if (host !== document.body && !host.querySelector('.jodi-tabs')) {
      host.style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();


/* ------------------------------------------------------------------
   Produktkarten: alle Karten einer Reihe gleich hoch (shopweit).
   Unabhängig vom Reiter-Skript oben. Misst jede Karte, gruppiert nach
   Reihe (gleiche Oberkante) und setzt alle auf die höchste Karte der
   Reihe. Läuft neu bei Größenänderung, nach dem Laden der Bilder und
   wenn Filter/Sortierung die Liste austauschen.
   ------------------------------------------------------------------ */
(function () {
  var SEL = '.grid-product__content';
  var timer;

  function angleichen() {
    var karten = [].slice.call(document.querySelectorAll(SEL));
    if (!karten.length) return;
    karten.forEach(function (k) { k.style.minHeight = ''; });

    var reihen = {};
    karten.forEach(function (k) {
      if (!k.offsetParent) return;               /* ausgeblendet */
      var top = Math.round(k.getBoundingClientRect().top + window.scrollY);
      var key = Object.keys(reihen).find(function (t) { return Math.abs(t - top) < 4; });
      (reihen[key || top] = reihen[key || top] || []).push(k);
    });
    Object.keys(reihen).forEach(function (t) {
      var reihe = reihen[t];
      if (reihe.length < 2) return;
      var max = Math.max.apply(null, reihe.map(function (k) { return k.offsetHeight; }));
      reihe.forEach(function (k) { k.style.minHeight = max + 'px'; });
    });
  }

  function spaeter() { clearTimeout(timer); timer = setTimeout(angleichen, 80); }

  function start() {
    angleichen();
    window.addEventListener('resize', spaeter);
    window.addEventListener('load', angleichen);
    document.addEventListener('load', function (e) {
      if (e.target.tagName === 'IMG' && e.target.closest(SEL)) spaeter();
    }, true);
    var main = document.getElementById('MainContent') || document.body;
    new MutationObserver(function (liste) {
      for (var i = 0; i < liste.length; i++) {
        if (liste[i].type === 'childList') { spaeter(); return; }
      }
    }).observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', spaeter);
})();
